import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ItemTableView.html?raw';



import StaticTable from '../../../../../moreCore/UI/StaticTable/StaticTable';

class ItemTableView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    tableContainer: HTMLDivElement;
    url: string = window.appRoot + "Typescript/WidgetCollection/Wizards/TransportIntermodal/DispoSections/ItemTableView/data.json";

  
    createTable(data: any): void {

        this.UiModder.domConstruct.empty(this.tableContainer);
        let table = new StaticTable();
        table.setData(data.entityList);
        table.setTableLayout(data.tableLayouts[0]);
        table.setRowClick(lang.hitch(this, this._RowClick));
        table.setCyAttribute("TransportIntermodalItemTable");

        this.UiModder.domConstruct.place(table.domNode, this.tableContainer);
        //this.StandbyStop();

        this.emit("tableCreated");
        this.StandbyStop();
        
    }

    _RowClick(row: StaticTable.StaticTableRow<any>, data: StaticTable.StaticTableRowGroup<any>) {
        let entity = data.entity;
        //console.log("entity", entity);
        //location.href = window.appRoot + "DOT/DownloadContract";

        this.emit("RowClick", entity);
    }



 
  

    loadDataResponse(jsonData): void {

        this.StandbyStart();

        this.RequestManager.post(this.url,
            { "jsonData": JSON.stringify(jsonData) },

            lang.hitch(this, this.createTable),

            function () {

            }
        );
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        //this.loadDataResponse();

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ItemTableView);

//WidgetCollection/DashboardWidgets/DOT/MyContracts/MyContracts